// extracted by mini-css-extract-plugin
export default {"wrapper":"candidate-list-message_wrapper__ADj+m","bounceIn":"candidate-list-message_bounceIn__kHLDp","answers":"candidate-list-message_answers__Zii1H"};